// extracted by mini-css-extract-plugin
export default {"header":"ShredAnnotatedDocumentModal_header__w6SsP","body":"ShredAnnotatedDocumentModal_body__GuExL"};